import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { QuotationDocument } from './QuotationView';
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function PublicPortfolioSet() {
  const { id } = useParams();
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(`${BACKEND}/api/public/portfolio-set/${id}`).then(r => setD(r.data)).catch(e => setD({ error: true, status: e.response?.status })); }, [id]);
  if (!d) return <div className="p-6 text-sm text-[var(--muted)]">Loading…</div>;
  if (d.error) return <div className="p-8 text-center serif text-[24px]">{d.status===410?'This set has expired.':'Set not found.'}</div>;
  const { set: s, assets, settings } = d;
  return (
    <div className="min-h-screen py-6 px-4" style={{background:'var(--cream-alt)'}}>
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 pt-6">
          <div className="serif text-[36px]">{s.title || s.name}</div>
          <div className="eyebrow mt-2">Rishika Sharma</div>
          <div className="gold-rule my-4 mx-auto" style={{width:60}}/>
          {s.intro && <div className="text-sm text-[var(--muted)] max-w-lg mx-auto italic">{s.intro}</div>}
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          {assets.map(a => (
            <div key={a.id} className="aspect-square overflow-hidden bg-[var(--cream)] rounded-sm">
              {a.url && <img src={a.url} alt={a.caption} className="w-full h-full object-cover" style={{objectPosition:'center'}}/>}
            </div>
          ))}
        </div>
        <div className="text-center text-xs text-[var(--muted)] mt-10 pb-6 tracking-[0.14em]">
          <div className="serif text-[16px] mb-1" style={{color:'var(--charcoal)'}}>{settings?.brand_name}</div>
          {settings?.location_line} · {settings?.phone} · {settings?.instagram} · {settings?.website}
        </div>
      </div>
    </div>
  );
}
